import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import {
  required,
  maxLength,
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";

export default {
  name: "LeaveTypeCreate",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      isLoading: false,
      leave_type: "",
      is_paid: null,
      description: "",
      submitted: false,
      disabled: false,
      methodExists: {},
      STATUS: CONFIG.LEAVE_TYPE_STATUS,
      CONFIG,
    };
  },

  validations: {
    leave_type: {
      required,
      maxLength: maxLength(100)
    },
    description: {
      maxLength: maxLength(1000)
    },
    is_paid: {
      required
    }
  },

  watch: {
    leave_type() {
      if (this.methodExists.type) {
        this.methodExists.type = [];
      }
    }
  },

  methods: {
    async confirmRegister() {
      this.submitted = true;
      this.disabled = true;
      this.$v.$touch();
      if (this.$v.$invalid || this.leave_type == '' || this.leave_type == 0) {
        this.disabled = false;
        return;
      }
      this.register();
    },

    register() {
      this.disabled = true;
      var request = {
        type: this.leave_type,
        is_paid: this.is_paid,
        is_default: false,
        total_day: null,
        description: this.description,
      }
      axios.post("/leaveType/create", request, {
        headers: {
          'Content-Type': 'application/json',
        }
      }) .then(response => {
        if (response.data) {
          this.$notification.success("Leave Type Added Successfully", {
            timer: 3,
            position: "bottomCenter"
          });
          if (this.$route.query.rd_back == 'leaveType') {
            this.$router.push({
              name: "leaveTypeCreate"
            });
          } else {
            this.$router.push({
              name: "leaveTypeList"
            });
          }
        }
      }) .catch(error => {
        this.disabled = false;
        if (error.response?.status === 422) {
          this.methodExists = error.response.data.errors || {};
        } else if (error.response?.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          console.error("Unexpected error:", error);
        }
      });
    },

    showList() {
      this.$router.push({
        path: "/leaveType/list"
      });
    },
  },
};
